import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import NVPieChart from "common/graphs/NVPieChart";
import ActionsContext from "common/ActionsContext";

const BigGraph = styled.div`
  &,
  & svg {
    min-height: 12cm;
  }
  @media print {
    width: 100% !important;
    overflow: hidden;
  }
  .align-right {
    float: right;
  }
`;

const valueFrom = (field) => (d) => d[field];

const sessionsTooltip =
  (units = "sessions") =>
  (d) =>
    d === null ? "N/A" : `${d} ${units}`;

const ReportResult = ({
  itemsValueFrom = "active",
  connections = [],
  yAxisUnits = "sessions",
}) =>
  <BigGraph className="big graph">
    <NVPieChart
      items={connections}
      xFrom={(d) => d.name}
      yFrom={valueFrom(itemsValueFrom)}
      yTooltipFormat={sessionsTooltip(yAxisUnits)}
      labelType="value"
      yAxisUnits={yAxisUnits}
    />
  </BigGraph>

const thoseActive = ({ active = 0 }) => active > 0;

const Report = ({ retrieval }) => {
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  const doLoad = () => {
    setRequest(retrieval());
  };
  useEffect(() => (doLoad(), actions.recv("do-load", doLoad)), []);
  return request === null ? null : (
    <Request during={request}>
      {({ connections }) => (
        <ReportResult connections={connections.filter(thoseActive)}/>
      )}
    </Request>
  );
};

export default Report;
